{
  "loading": "Cargando comentarios...",
  "title": "Comentarios ({{total}})",
  "placeholder": "Deja tu comentario...",
  "submit": "Comentar",
  "empty": "Aún no hay comentarios. ¡Sé el primero!",
  "badges": {
    "admin": "Admin",
    "instructor": "Instructor"
  },
  "edited": "(editado)",
  "actions": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "reply": "Responder",
    "edit": "Editar",
    "pin": "Fijar",
    "unpin": "Desfijar",
    "delete": "Eliminar"
  },
  "replyPlaceholder": "Escribe una respuesta...",
  "viewReplies_one": "Ver {{count}} respuesta",
  "viewReplies_zero": "Ver {{count}} respuestas",
  "viewReplies_other": "Ver {{count}} respuestas",
  "toast": {
    "created": "¡Comentario publicado correctamente!",
    "createError": "Error al publicar el comentario",
    "updated": "¡Comentario actualizado!",
    "updateError": "Error al actualizar el comentario",
    "deleted": "¡Comentario eliminado!",
    "deleteError": "Error al eliminar el comentario",
    "pinToggled": "¡Comentario fijado/desfijado!",
    "pinError": "Error al fijar el comentario"
  }
}
